import React from "react";
import BaseDataAssetList from "./baseDataAssetList";

const DataAssetSearchAssetList = ({ shouldGrabFocus = true, title = null }) => {
  return (
    <BaseDataAssetList
      shouldGrabFocus={shouldGrabFocus}
      title={title}
      excludedFilters={[]}
      enableDataSetSave
    />
  );
};

export default DataAssetSearchAssetList;
